import { render } from "./CrewMembers.vue?vue&type=template&id=80c1283c"
import script from "./CrewMembers.vue?vue&type=script&lang=js"
export * from "./CrewMembers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__